import React, { useState, useEffect } from "react";
import Datepicker from "../../fixedassetelements/datepicker/Datepicker";
import {
  AddregButton,
  FilterIcon,
  SyncButton,
  UploadFileButton,
} from "../../fixedassetelements/button/Button";

import SyncPopup from "../SyncButton/SyncButton";
import UploadExcelModal from "../common/UploadExcelModal/UploadExcelModal";
import CustomFilter from "../filterIcon/CustomFilter";
import AddPurchaseRegister from "../forms/AddPurchaseRegister/AddPurchaseRegister";
import UploadPurchaseFile from "../forms/UploadFile/UploadFile";
import PurchaseUploadedFiles from "../forms/PurchaseUploadedFiles/PurchaseUploadedFile";
import ColumnMapping from "../forms/ColumnMappingForm/ColumnMapping";
import Submapping from "../forms/SubMapping/Submapping";
import ERPModal from "../common/ERPModal/ERPModal";
import SyncERPSuccess from "../SyncButton/SyncERPSuccess";
import AppendReplaceFile from "../common/AppendReplacePopup/AppendReplacePopup";
import { purchaseListing } from "../../../Bookclosure/Services/ApiHandler";
import { GetPurchase } from "../../../WorkSpace/Components/ApiServices/apiHandler";

import styles from "./PurchaseregHeader.module.css";

const PurchaseRegHeaders = ({
  PurchaseID,
  setShowDataState,
  tableType,
  setTableType,
  setShowTable,
  onFiltersApplied,
  showAddRegisterModal,
  setShowAddRegisterModal,
}) => {
  const [asOnDate, setAsOnDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  //const [showAddRegisterModal, setShowAddRegisterModal] = useState(false);
  const [showUploadExcelModal, setShowUploadExcelModal] = useState(false);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [showPurchaseUploadedFiles, setShowPurchaseUploadedFiles] =
    useState(false);
  const [showColumnMapping, setShowColumnMapping] = useState(false);
  const [showSubMapping, setShowSubMapping] = useState(false);
  const [showERPModal, setShowERPModal] = useState(false);
  const [showERPSuccessModal, setShowERPSuccessModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showAppendReplacePopup, setShowAppendReplacePopup] = useState(false);

  const [uploadAction, setUploadAction] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadType, setUploadType] = useState(null);
  const [selectedFileIndex, setSelectedFileIndex] = useState(null);
  const [mappedFileName, setMappedFileName] = useState(null);

  const [filterConfig, setFilterConfig] = useState([]);

  const formatDateInputValue = (value) => {
    if (!value) return "";
    const date = new Date(value);
    return !isNaN(date.getTime()) ? date.toISOString().split("T")[0] : "";
  };

  const resolveAsOnDateFromItems = (items, id) => {
    if (!Array.isArray(items)) return "";
    const match = items.find(
      (item) =>
        item &&
        (item._id === id ||
          item.id === id ||
          item.saleID === id ||
          item.purchaseID === id ||
          item.fixedAssetID === id)
    );
    if (match?.createdAt) {
      return formatDateInputValue(match.createdAt);
    }
    const firstCreatedAt = items.find((item) => item?.createdAt)?.createdAt;
    return formatDateInputValue(firstCreatedAt);
  };

  useEffect(() => {
    const fetchFilterConfig = async () => {
      try {
        const response = await purchaseListing(PurchaseID, {
          page: 1,
          pageSize: 30,
          filters: [],
        });
        if (response.data && response.data.filterAndAlignment) {
          setFilterConfig(response.data.filterAndAlignment);
        }
        if (response.data?.purchaseListing?.length > 0) {
          setShowTable(true);
          setShowDataState(false);
          setTableType("excel");
        }
      } catch (error) {
        console.error("Failed to fetch filter config:", error);
      }
    };

    const fetchAsOnDate = async () => {
      if (!PurchaseID) {
        setAsOnDate(new Date().toISOString().split("T")[0]);
        return;
      }

      try {
        const response = await GetPurchase();
        const purchases = response.data?.purchases || response.data?.Purchase || response.data?.result || [];
        const dateFromPurchases = resolveAsOnDateFromItems(purchases, PurchaseID);
        if (dateFromPurchases) {
          setAsOnDate(dateFromPurchases);
          return;
        }

        const listingDate = formatDateInputValue(response.data?.purchaseListing?.[0]?.createdAt);
        setAsOnDate(listingDate || new Date().toISOString().split("T")[0]);
      } catch (error) {
        console.error("Failed to fetch purchase createdAt:", error);
        setAsOnDate(new Date().toISOString().split("T")[0]);
      }
    };

    if (PurchaseID) {
      fetchFilterConfig();
      fetchAsOnDate();
    }
  }, [PurchaseID]);

  const handleApplyFilter = (filters) => {
    console.log("Filters received:", filters);
    setShowFilter(false);

    setShowTable(true);
    setShowDataState(false);

    if (onFiltersApplied) {
      onFiltersApplied(filters);
    }
  };

  const handleSelect = (type) => {
    if (type === "uploadExcelModal") {
      setShowAddRegisterModal(false);
      setShowUploadExcelModal(true);
    } else if (type === "erp") {
      setShowAddRegisterModal(false);
      setShowERPModal(true);
    }
  };

  const handleSelectUploadType = (type) => {
    setUploadType(type);
    setShowUploadExcelModal(false);
    setShowUploadFileModal(true);
  };

  const handleProceedToPurchaseUploadedFiles = (files) => {
    const normalized = (files || []).map((file) => {
      const computedName =
        file?.name ||
        file?.fileName ||
        file?.originalname ||
        file?.displayName ||
        file?.file?.name ||
        file?.file?.fileName ||
        file?.file?.originalname ||
        "Untitled file";

      return {
        rawFile: file,
        displayName: computedName,
        isMapped: false,
      };
    });
    setUploadedFiles((prev) => [...prev, ...normalized]);
    setShowUploadFileModal(false);
    setShowPurchaseUploadedFiles(true);
  };

  const handleStartMapping = (index) => {
    setSelectedFileIndex(index);
    setShowPurchaseUploadedFiles(false);
    setShowColumnMapping(true);
  };

  const handleContinueMapping = () => {
    setShowColumnMapping(false);
    setShowSubMapping(true);
  };

  const handleSubmappingSuccess = () => {
    if (selectedFileIndex !== null) {
      setUploadedFiles((prev) =>
        prev.map((item, idx) =>
          idx === selectedFileIndex ? { ...item, isMapped: true } : item
        )
      );
      const mappedItem = uploadedFiles[selectedFileIndex];
      const mappedName =
        mappedItem?.name ||
        mappedItem?.displayName ||
        mappedItem?.file?.name ||
        mappedItem?.fileName ||
        mappedItem?.originalname;
      if (mappedName) setMappedFileName(mappedName);
    }
    setShowSubMapping(false);
    setShowPurchaseUploadedFiles(true);
  };

  const handleSubmitSubMapping = () => {
    // kept for compatibility; Submapping now calls handleSubmappingSuccess directly
    setShowSubMapping(false);
    setShowPurchaseUploadedFiles(true);
  };

  const handleRemoveFile = (index) => {
   setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddFiles = () => {
    setShowUploadFileModal(true);
    setShowPurchaseUploadedFiles(false);
  }

  const handleFinish = () => {
    const canFinish = uploadedFiles.some((file) => file.isMapped);
    if (!canFinish) {
      alert("Please map at least one file before finishing.");
      return;
    }
    setShowPurchaseUploadedFiles(false);
    setShowDataState(false);
    setTableType("excel");
    setShowTable(true);
  };

  const handleSuccessERPModal = () => {
    setShowERPModal(false);
    setShowERPSuccessModal(true);
  };

  const handleERPComplete = () => {
    setShowERPSuccessModal(false);
    setShowDataState(false);
    setTableType("erp");
    setShowTable(true);
  };

  const handleAppendReplaceSelect = (action) => {
    setUploadAction(action);
    setShowAppendReplacePopup(false);
    setShowUploadExcelModal(true);
  };
  return (
    <>
      <div className={styles.header}>
        <div className={styles.rightSection}>
          <FilterIcon onClick={() => setShowFilter(true)} />

          <Datepicker
            date={asOnDate}
            onChange={(e) => setAsOnDate(e.target.value)}
            label="As on"
          />

          {tableType === "erp" && (
            <SyncButton onClick={() => setShowPopup(true)} />
          )}
          {tableType === "excel" && (
            <UploadFileButton onClick={() => setShowAppendReplacePopup(true)} />
          )}
          {tableType === null && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
        </div>
      </div>

      {showAddRegisterModal && (
        <AddPurchaseRegister
          onClose={() => setShowAddRegisterModal(false)}
          handleSelect={handleSelect}
        />
      )}

      {showUploadExcelModal && (
        <UploadExcelModal
          onClose={() => setShowUploadExcelModal(false)}
          onBack={() => {
            setShowUploadExcelModal(false);
            setShowAddRegisterModal(true);
          }}
          onSelectUploadType={handleSelectUploadType}
        />
      )}

      {showUploadFileModal && (
        <UploadPurchaseFile
          PurchaseID={PurchaseID}
          onClose={() => {
           setShowUploadFileModal(false);
           setUploadedFiles([]);
          }}
          onBack={() => {
            setShowUploadFileModal(false);
            setShowUploadExcelModal(true);
          }}
          onProceedToPurchaseUploadedFiles={
            handleProceedToPurchaseUploadedFiles
          }
        />
      )}

      {showPurchaseUploadedFiles && (
        <PurchaseUploadedFiles
          uploadedFiles={uploadedFiles}
          canFinish={uploadedFiles.some((file) => file.isMapped)}
          onBack={() => {
            setShowPurchaseUploadedFiles(false);
            setShowUploadFileModal(true);
            setUploadedFiles([]);
          }}
          onStartMapping={handleStartMapping}
          onFinish={handleFinish}
          onRemove={handleRemoveFile}
          onAdd={handleAddFiles}
          onClose={() => {
            setShowPurchaseUploadedFiles(false);
            setUploadedFiles([]);
          }}
        />
      )}

      {showColumnMapping && (
        <ColumnMapping
          PurchaseID={PurchaseID}
          onBack={() => {
            setShowColumnMapping(false);
            setShowPurchaseUploadedFiles(true);
          }}
          onContinue={handleContinueMapping}
          onClose={() => {
            setUploadedFiles([]);
            setShowColumnMapping(false) }}
        />
      )}

      {showSubMapping && (
        <Submapping
          PurchaseID={PurchaseID}
          onBack={() => {
            setShowSubMapping(false);
            setShowColumnMapping(true);
          }}
          onMapped={handleSubmappingSuccess}
          onClose={() => {
            setShowSubMapping(false);
            setShowPurchaseUploadedFiles(true);
          }}
        />
      )}

      {showERPModal && (
        <ERPModal
          onClose={() => setShowERPModal(false)}
          onBack={() => {
            setShowERPModal(false);
            setShowAddRegisterModal(true);
          }}
          onProceed={handleSuccessERPModal}
        />
      )}

      {showERPSuccessModal && <SyncERPSuccess onClose={handleERPComplete} />}

      {showFilter && (
        <CustomFilter
          onClose={() => setShowFilter(false)}
          onApply={handleApplyFilter}
          filterConfig={filterConfig}
        />
      )}
      {showPopup && <SyncPopup onClose={() => setShowPopup(false)} />}

      {showAppendReplacePopup && (
        <AppendReplaceFile
          onClose={() => setShowAppendReplacePopup(false)}
          onSelectUploadType={handleAppendReplaceSelect}
        />
      )}
    </>
  );
};

export default PurchaseRegHeaders;
